import { render, staticRenderFns } from "./ExpandableOrderStatus.vue?vue&type=template&id=d45a10de&scoped=true&"
import script from "./ExpandableOrderStatus.vue?vue&type=script&lang=js&"
export * from "./ExpandableOrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableOrderStatus.vue?vue&type=style&index=0&id=d45a10de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45a10de",
  null
  
)

export default component.exports